import thunk from 'redux-thunk';
import { applyMiddleware, createStore } from 'redux';

import reducers from '../reducers';
import { chatMiddleware } from '../middlewares/chatMiddleware';
import { composeWithDevTools } from 'redux-devtools-extension';

const initialState = window.INITIAL_STATE;
const middlewares = [chatMiddleware, thunk];
let applyFunction = (middlewares) => applyMiddleware(...middlewares);

if (process.env.NODE_ENV !== 'production') {
  const { createLogger } =  require('redux-logger'); // eslint-disable-line global-require
  const reduxLogger = createLogger();

  // Adding redux logger to middleware stack
  middlewares.push(reduxLogger);

  // Enabling redux devTools
  applyFunction = (middlewares) => composeWithDevTools(applyMiddleware(...middlewares));
}

export default createStore(reducers, applyFunction(middlewares));



// WEBPACK FOOTER //
// ./src/redux/stores/store.jsx